import { render, staticRenderFns } from "./QCard.vue?vue&type=template&id=3d1fcdf1&"
import script from "./QCard.vue?vue&type=script&lang=js&"
export * from "./QCard.vue?vue&type=script&lang=js&"
import style0 from "./QCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports